// extracted by mini-css-extract-plugin
export default {"blueBorderedButton":"BlueBorderButton_blueBorderedButton__SB41i"};